
import axios from "@/axios.js"

export default {
  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/statistiqueArtisans")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchInterventionsStatistics({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/interventions/statistique")
        .then((response) => {
          commit('SET_INTERVENTIONS_STATISTICS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
